export default __webpack_public_path__ + "1ca6318d80b797908c6b177ff0a80622.woff2";